<!--
  ~ Copyright (c) 2022 Certusoft, Inc. All Rights Reserved.
  ~
  ~ This SOURCE CODE FILE, which has been provided by Certusoft as part
  ~ of a Certusoft product for use ONLY by licensed users of the product,
  ~ includes CONFIDENTIAL and PROPRIETARY information of Certusoft.
  ~
  ~ USE OF THIS SOFTWARE IS GOVERNED BY THE TERMS AND CONDITIONS
  ~ OF THE LICENSE STATEMENT AND LIMITED WARRANTY FURNISHED WITH
  ~ THE PRODUCT.
  -->

<!-- Render Panel -->
<div
    class="full-height full-width"
    id="container"
    [ngClass]="[collapsed ? 'container-expanded' : 'container-collapsed']"
>
    <iframe class="render-container" [src]="rendererURL" id="render-container"></iframe>
    <div class="data-manager-info">
        <span class="data-manager-item"><b>Data Manager</b></span>
        <span class="data-manager-item">{{
                'Project: ' + (dataManagerInfo.projectName ? dataManagerInfo.projectName : 'Default')
            }}</span>
        <span class="data-manager-item">{{
                'Tag: ' + (dataManagerInfo.tagName ? dataManagerInfo.tagName : 'None')
            }}</span>
    </div>
</div>

<!-- Sidebar -->
<div class="full-height full-width" id="menu" [ngClass]="[collapsed ? 'menu-collapsed' : 'menu-expanded']">
    <span class="collapse-toggle" (click)="collapsed = !collapsed">
        <i class="icon-chevron glyphicon glyphicon-triangle-right" *ngIf="!collapsed"></i>
        <i class="icon-chevron glyphicon glyphicon-triangle-left" *ngIf="collapsed"></i>
    </span>

    <!-- Part Selection -->
    <div id="tabs">
        <div ngbPanelHeader>
            <!-- Mode Selector -->
            <ul class="nav nav-tabs">
                <li class="nav-item" [ngClass]="[mode === threedMode.DATA_MANAGER ? 'active' : '']">
                    <a class="nav-link" (click)="updateMode(threedMode.DATA_MANAGER)">Data Manager</a>
                </li>
                <li class="nav-item" [ngClass]="[mode === threedMode.VIEW ? 'active' : '']">
                    <a class="nav-link" (click)="updateMode(threedMode.VIEW)">View</a>
                </li>
                <li class="nav-item" [ngClass]="[mode === threedMode.DATUM ? 'active' : '']">
                    <a class="nav-link" (click)="updateMode(threedMode.DATUM)">Component</a>
                </li>
                <li class="nav-item" [ngClass]="[mode === threedMode.SUBCAT ? 'active' : '']">
                    <a class="nav-link" (click)="updateMode(threedMode.SUBCAT)">Subcategory</a>
                </li>
                <!--          <li class="nav-item" [ngClass]="[mode==='RULE'?'active':'']">-->
                <!--            <a class="nav-link" (click)="mode = 'RULE'">Rule</a>-->
                <!--          </li>-->
            </ul>
        </div>
    </div>

    <div class="panel-container">
        <!-- Data Manager -->
        <app-datamanager
            *ngIf="mode === threedMode.DATA_MANAGER"
            (changeEvent)="dataManagerChange($event)"
        ></app-datamanager>

        <ngb-accordion
            id="accordion-main"
            [closeOthers]="true"
            activeIds="pre-transform"
            (panelChange)="onPanelChange($event, this)"
            *ngIf="mode !== threedMode.DATA_MANAGER"
        >
            <!-- Part Selector -->
            <ngb-panel id="title">
                <ng-template ngbPanelHeader let-opened="opened">
                    <div class="custom-dropdown-container">
                        <div class="custom-dropdown" *ngIf="mode === threedMode.SUBCAT">
                            <input
                                class="custom-dropdown-input"
                                [(ngModel)]="currentSubcategoryInput"
                                (ngModelChange)="updateSubcatInput()"
                                [placeholder]="subcategoriesLoading ? 'Retrieving...' : ''"
                                (focusin)="subcatFocused = true"
                                (focusout)="subcatFocused = false"
                                [disabled]="loading"
                            />
                            <button class="clear-field btn btn-link p-0" [ngClass]="[currentSubcategoryInput.length<30?'':'clear-field-alt']" (click)="currentSubcategoryInput = ''" [disabled]="loading">
                                <i class="glyphicon glyphicon-remove-sign"></i>
                            </button>
                            <i class="glyphicon glyphicon-chevron-down" *ngIf='currentSubcategoryInput.length<30'></i>
                            <div class="custom-dropdown-panel" *ngIf="subcatFocused">
                                <ul>
                                    <li
                                        class="custom-dropdown-item"
                                        *ngFor="let subcat of filteredSubcategoriesList"
                                        (mousedown)="updateSubcat(subcat)"
                                    >
                                        {{ subcat }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="custom-dropdown" *ngIf="mode !== threedMode.SUBCAT || currentSubcategory">
                            <input
                                class="custom-dropdown-input"
                                [(ngModel)]="currentPartInput"
                                (ngModelChange)="updatePartInput()"
                                [placeholder]="partsLoading ? 'Retrieving...' : ''"
                                (focusin)="partFocused = true"
                                (focusout)="partFocused = false"
                                [disabled]="loading"
                            />
                            <button class="clear-field btn btn-link p-0" [ngClass]="[currentPartInput.length<30?'':'clear-field-alt']" (click)="currentPartInput = ''" [disabled]="loading">
                                <i class="glyphicon glyphicon-remove-sign"></i>
                            </button>
                            <i class="glyphicon glyphicon-chevron-down" *ngIf='currentPartInput.length<30'></i>
                            <div class="custom-dropdown-panel" *ngIf="partFocused">
                                <ul>
                                    <li
                                        class="custom-dropdown-item"
                                        *ngFor="let part of filteredPartsList"
                                        (mousedown)="changePart(part)"
                                    >
                                        {{ part }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="controls">
                        <button
                            class="btn btn-link p-0"
                            (click)="saveDatum()"
                            *ngIf="currentPart && mode !== threedMode.VIEW"
                            title="{{
                                mode === threedMode.DATUM
                                    ? 'Save All Descriptions to ComponentDatumTransform and Pre-Transform to ComponentDrawing'
                                    : 'Save All Descriptions to ComponentSubcategory'
                            }}"
                        >
                            <span *ngIf="anySaveDirty()">*</span>
                            Save All
                        </button>
                        <mat-spinner [diameter]="25" *ngIf="loading || featurePromise"></mat-spinner>
                    </div>
                    <div
                        class="currently-editing"
                        *ngIf="mode !== threedMode.VIEW && (currentPart || currentSubcategory)"
                    >
                        <span>Currently Editing:</span>
                        <table>
                            <thead>
                            <tr>
                                <th scope="col" class="cell">Property</th>
                                <th scope="col" class="cell">Instance Name</th>
                                <th scope="col" class="cell">Type Name</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngIf="mode === threedMode.DATUM">
                                <td class="cell">Pre-Transform</td>
                                <td class="cell">{{ currentPart }}</td>
                                <td class="cell">AAE:ComponentDrawing</td>
                            </tr>
                            <tr *ngIf="mode === threedMode.DATUM">
                                <td class="cell">Datum Descriptions</td>
                                <td class="cell">{{ currentPart }}</td>
                                <td class="cell">AAE:ComponentDatumTransform</td>
                            </tr>
                            <tr *ngIf="mode === threedMode.SUBCAT">
                                <td class="cell">Datum Templates</td>
                                <td class="cell">{{ currentSubcategory }}</td>
                                <td class="cell">AAE:ComponentSubcategory</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </ng-template>
            </ngb-panel>

            <!-- Pre-Transform Selection -->
            <ngb-panel id="pre-transform">
                <ng-template ngbPanelHeader let-opened="opened">
                    <button ngbPanelToggle class="btn btn-link p-0">
                        <i class="icon-chevron glyphicon glyphicon-triangle-right" *ngIf="!opened"></i>
                        <i class="icon-chevron glyphicon glyphicon-triangle-bottom" *ngIf="opened"></i>
                        Pre-Transform
                    </button>
                    <div class="controls">
                        <button class="btn btn-link p-0" (click)="toggleTransparency()" *ngIf="currentPart">
                            <i class="glyphicon glyphicon-sunglasses" title="Toggle Transparency"></i>
                        </button>
                        <button
                            class="btn btn-link p-0"
                            *ngIf="mode === threedMode.DATUM"
                            [disabled]="!(partInfo.preTransform.up && partInfo.preTransform.front)"
                            (click)="updatePreTransform(true)"
                            title="Save pre-transform to ComponentDrawing"
                        >
                            Save
                        </button>
                    </div>
                </ng-template>
                <ng-template ngbPanelContent>
                    <div class="pre-transform-content">
                        <label for="pre-transform-up">Up</label>
                        <select
                            id="pre-transform-up"
                            [disabled]="!currentPart"
                            [(ngModel)]="partInfo.preTransform.up"
                            (ngModelChange)="updatePreTransform()"
                        >
                            <option
                                *ngFor="let axis of generatePreTransformAxesOptions(partInfo.preTransform.front)"
                                [value]="axis"
                                [selected]=""
                            >
                                {{ axis }}
                            </option>
                        </select>
                        <label for="pre-transform-front">Front</label>
                        <select
                            id="pre-transform-front"
                            [disabled]="!currentPart"
                            [(ngModel)]="partInfo.preTransform.front"
                            (ngModelChange)="updatePreTransform()"
                        >
                            <option
                                *ngFor="let axis of generatePreTransformAxesOptions(partInfo.preTransform.up)"
                                [value]="axis"
                                [selected]=""
                            >
                                {{ axis }}
                            </option>
                        </select>
                        <span
                            class="warning warning-pre-transform"
                            *ngIf="partInfo.datumList && partInfo.datumList.length > 0"
                        >
                            *Warning: Updating Pre-Transform may affect datum specifications
                        </span>
                        <span class="warning warning-pre-transform" *ngIf="disablePreTransform">
                            *Warning: Existing Pre-Transform value not recognized
                        </span>

                        <fieldset *ngIf="preTransform.length > 0" [disabled]="true" id="pre-transform-matrix">
                            <label>Transform Name: </label>
                            <span>{{ preTransformName }}</span>
                            <table>
                                <tbody>
                                <tr>
                                    <td><input type="number" [(ngModel)]="preTransform[0]" /></td>
                                    <td><input type="number" [(ngModel)]="preTransform[1]" /></td>
                                    <td><input type="number" [(ngModel)]="preTransform[2]" /></td>
                                    <td><input type="number" [(ngModel)]="preTransform[3]" /></td>
                                </tr>
                                <tr>
                                    <td><input type="number" [(ngModel)]="preTransform[4]" /></td>
                                    <td><input type="number" [(ngModel)]="preTransform[5]" /></td>
                                    <td><input type="number" [(ngModel)]="preTransform[6]" /></td>
                                    <td><input type="number" [(ngModel)]="preTransform[7]" /></td>
                                </tr>
                                <tr>
                                    <td><input type="number" [(ngModel)]="preTransform[8]" /></td>
                                    <td><input type="number" [(ngModel)]="preTransform[9]" /></td>
                                    <td><input type="number" [(ngModel)]="preTransform[10]" /></td>
                                    <td><input type="number" [(ngModel)]="preTransform[11]" /></td>
                                </tr>
                                <tr>
                                    <td><input type="number" [(ngModel)]="preTransform[12]" /></td>
                                    <td><input type="number" [(ngModel)]="preTransform[13]" /></td>
                                    <td><input type="number" [(ngModel)]="preTransform[14]" /></td>
                                    <td><input type="number" [(ngModel)]="preTransform[15]" /></td>
                                </tr>
                                </tbody>
                            </table>
                        </fieldset>
                    </div>
                </ng-template>
            </ngb-panel>

            <!-- Subcategory Assignment -->
            <ngb-panel id="subcategories" *ngIf="currentPart && mode === threedMode.DATUM">
                <ng-template ngbPanelHeader let-opened="opened">
                    <button ngbPanelToggle class="btn btn-link p-0">
                        <i class="icon-chevron glyphicon glyphicon-triangle-right" *ngIf="!opened"></i>
                        <i class="icon-chevron glyphicon glyphicon-triangle-bottom" *ngIf="opened"></i>
                        Subcategories
                    </button>
                    <div class="controls">
                        <button
                            class="btn btn-link p-0"
                            [disabled]="selectedSubcategories.length == 0"
                            (click)="generateDatum(false)"
                            title="Generate from subcategory-level descriptions (preserve existing)"
                        >
                            <i class="glyphicon glyphicon-folder-open"></i>
                            <i class="glyphicon-overlay glyphicon glyphicon-play"></i>
                        </button>
                        <button
                            class="btn btn-link p-0"
                            [disabled]="selectedSubcategories.length == 0"
                            (click)="generateDatum(true)"
                            *ngIf="partInfo.datumList && partInfo.datumList.length > 0"
                            title="Regenerate from subcategory-level descriptions (overwrite all)"
                        >
                            <i class="glyphicon glyphicon-folder-open"></i>
                            <i class="glyphicon-overlay glyphicon glyphicon-repeat"></i>
                        </button>
                    </div>
                </ng-template>
                <ng-template ngbPanelContent>
                    <div class="datum-content">
                        <fieldset
                            [disabled]="partInfo.datumList && partInfo.datumList.length > 0"
                            class="subcategory-content"
                        >
                            <div *ngFor="let subcategory of selectedSubcategories; let i = index">
                                <input [(ngModel)]="selectedSubcategories[i]" [disabled]="true" />
                                <button
                                    class="btn btn-link p-0"
                                    (click)="removeSubcategory(i)"
                                    title="Remove Subcategory"
                                >
                                    <i class="glyphicon glyphicon-remove"></i>
                                </button>
                            </div>
                            <!-- Hide dropdown, selections are driven by rules -->
                            <!--              <select id="{{'subcategory-current'}}" [(ngModel)]="currentSubcategory" (ngModelChange)="updateSubcategories(currentSubcategory)">-->
                            <!--                <option *ngFor="let subcat of generateSubcatOptions()" [value]="subcat" [selected]="">{{subcat}}</option>-->
                            <!--              </select>-->
                        </fieldset>
                    </div>
                </ng-template>
            </ngb-panel>

            <!-- Datum Panels -->
            <ngb-panel *ngFor="let datum of partInfo.datumList; let i = index" id="{{ 'datum-' + i }}">
                <ng-template ngbPanelHeader let-opened="opened">
                    <div style="background-color: {{ i % 2 ? '#f7f9fb' : '#f1f3f5' }}" class="border-primary">
                        <button ngbPanelToggle class="btn btn-link p-0">
                            <i class="icon-chevron glyphicon glyphicon-triangle-right" *ngIf="!opened"></i>
                            <i class="icon-chevron glyphicon glyphicon-triangle-bottom" *ngIf="opened"></i>
                            <div class="color-box" style="background-color: {{ colorSet[i].hex }};"></div>
                            <div class="title-overflow" title="{{ datum.displayName || datum.name }}">
                                {{ datum.displayName || datum.name }}
                            </div>
                        </button>
                        <mat-spinner [diameter]="25" *ngIf="datum.loading > 0"></mat-spinner>
                        <div class="controls">
                            <button class="btn btn-link p-0" (click)="datum.toggleHidden()">
                                <i
                                    class="glyphicon glyphicon-eye-close"
                                    *ngIf="datum.hidden"
                                    title="Toggle Visibility"
                                ></i>
                                <i
                                    class="glyphicon glyphicon-eye-open"
                                    *ngIf="!datum.hidden"
                                    title="Toggle Visibility"
                                ></i>
                            </button>
                            <i
                                class="glyphicon glyphicon-ok"
                                *ngIf="datum.status === 'OK' && datum.loading == 0"
                                [ngClass]="'icon-' + datum.status"
                                title="Feature Detection Successful"
                            ></i>
                            <i
                                class="glyphicon glyphicon-alert"
                                *ngIf="datum.status === 'WARNING' && datum.loading == 0"
                                [ngClass]="'icon-' + datum.status"
                                title="Feature Detection Ambiguous"
                            ></i>
                            <i
                                class="glyphicon glyphicon-remove"
                                *ngIf="datum.status === 'ERROR' && datum.loading == 0"
                                [ngClass]="'icon-' + datum.status"
                                title="Feature Detection Failed"
                            ></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template ngbPanelContent>
                    <div class="datum-content" style="background-color: {{ i % 2 ? '#f7f9fb' : '#f1f3f5' }}">
                        <div>
                            <ngb-accordion [closeOthers]="true" activeIds="description-panel" id="transform">
                                <!-- Description Editor -->
                                <ngb-panel id="description-panel">
                                    <ng-template ngbPanelHeader let-opened="opened">
                                        <button ngbPanelToggle class="btn btn-link p-0">
                                            <i
                                                class="icon-chevron glyphicon glyphicon-triangle-right"
                                                *ngIf="!opened"
                                            ></i>
                                            <i
                                                class="icon-chevron glyphicon glyphicon-triangle-bottom"
                                                *ngIf="opened"
                                            ></i>
                                            Description
                                        </button>
                                        <div class="controls">
                                            <label
                                                *ngIf="
                                                    datum.getDatumEntityType() === entityType.TRANSFORM &&
                                                    mode === threedMode.DATUM
                                                "
                                            >Description Override</label
                                            >
                                            <input
                                                type="checkbox"
                                                *ngIf="
                                                    datum.getDatumEntityType() === entityType.TRANSFORM &&
                                                    mode === threedMode.DATUM
                                                "
                                                [(ngModel)]="datum.featureDescriptionOverride"
                                                title="Ignore Description and allow manual entering of Transform"
                                            />
                                            <button
                                                class="btn btn-link p-0"
                                                (click)="generateDatum(true, datum.name)"
                                                title="Regenerate from subcategory-level description (overwrite)"
                                            >
                                                <i class="glyphicon glyphicon-folder-open"></i>
                                                <i class="glyphicon-overlay glyphicon glyphicon-repeat"></i>
                                            </button>
                                            <button
                                                class="btn btn-link p-0"
                                                (click)="saveDatum(datum)"
                                                *ngIf="currentPart"
                                            >
                                                <i
                                                    class="glyphicon glyphicon-floppy-disk"
                                                    title="Save Description{{
                                                        mode === threedMode.DATUM ? ' and Transform' : ''
                                                    }} to {{
                                                        mode === threedMode.DATUM
                                                            ? 'ComponentDatumTransform'
                                                            : 'ComponentSubcategory'
                                                    }}"
                                                ></i>
                                                <span *ngIf="datum.saveDirty()">*</span>
                                            </button>
                                            <button
                                                class="btn btn-link p-0"
                                                [disabled]="datum.featureDescriptionOverride"
                                                (click)="updateDescription(datum)"
                                            >
                                                <i
                                                    class="glyphicon glyphicon-refresh"
                                                    title="Recompute Datum for Description"
                                                ></i>
                                                <span *ngIf="datum.descriptionDirty()">*</span>
                                            </button>
                                        </div>
                                    </ng-template>
                                    <ng-template ngbPanelContent>
                                        <app-feature-hint-input
                                            [datum]="datum"
                                            [assemblyKey]="assemblyKey"
                                            [partInfo]="partInfo"
                                            [mode]="mode"
                                            #featureInput
                                        ></app-feature-hint-input>
                                        <span class="warning" *ngIf="datum.status === 'ERROR'">
                                            *Error: Failed to parse feature description.
                                        </span>
                                        <span class="warning" *ngIf="datum.status === 'WARNING'">
                                            *Warning: Description did not detect a unique feature.
                                        </span>
                                        <span class="warning" *ngIf="!datum.entityTypeMatch">
                                            *Warning: Detected feature {{ datum.getDetectedEntityType() }} does not
                                            match datum type {{ datum.getDatumEntityType() }}.
                                        </span>
                                    </ng-template>
                                </ngb-panel>

                                <!-- Transform Matrix Editor -->
                                <ngb-panel id="matrix-panel">
                                    <ng-template ngbPanelHeader let-opened="opened">
                                        <button ngbPanelToggle class="btn btn-link p-0">
                                            <i
                                                class="icon-chevron glyphicon glyphicon-triangle-right"
                                                *ngIf="!opened"
                                            ></i>
                                            <i
                                                class="icon-chevron glyphicon glyphicon-triangle-bottom"
                                                *ngIf="opened"
                                            ></i>
                                            {{ entityTitle(datum.getEntityType()) }}
                                        </button>
                                        <div class="controls">
                                            <button
                                                class="btn btn-link p-0"
                                                [disabled]="!datum.featureDescriptionOverride"
                                                (click)="updateRenderedFeatures()"
                                            >
                                                <span *ngIf="datum.transformDirty()">*</span>
                                                <i class="glyphicon glyphicon-refresh" title="Reload transform"></i>
                                            </button>
                                        </div>
                                    </ng-template>
                                    <ng-template ngbPanelContent>
                                        <fieldset
                                            *ngIf="datum.getEntityType() === entityType.TRANSFORM"
                                            [disabled]="!datum.featureDescriptionOverride"
                                        >
                                            <table>
                                                <tbody>
                                                <tr>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [(ngModel)]="datum.values[0]"
                                                            (ngModelChange)="
                                                                    datum.transformDirty(true);
                                                                    updateDatumTransformFromMatrix(datum, datum.values)
                                                                "
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [(ngModel)]="datum.values[1]"
                                                            (ngModelChange)="
                                                                    datum.transformDirty(true);
                                                                    updateDatumTransformFromMatrix(datum, datum.values)
                                                                "
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [(ngModel)]="datum.values[2]"
                                                            (ngModelChange)="
                                                                    datum.transformDirty(true);
                                                                    updateDatumTransformFromMatrix(datum, datum.values)
                                                                "
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [(ngModel)]="datum.values[3]"
                                                            (ngModelChange)="
                                                                    datum.transformDirty(true);
                                                                    updateDatumTransformFromMatrix(datum, datum.values)
                                                                "
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [(ngModel)]="datum.values[4]"
                                                            (ngModelChange)="
                                                                    datum.transformDirty(true);
                                                                    updateDatumTransformFromMatrix(datum, datum.values)
                                                                "
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [(ngModel)]="datum.values[5]"
                                                            (ngModelChange)="
                                                                    datum.transformDirty(true);
                                                                    updateDatumTransformFromMatrix(datum, datum.values)
                                                                "
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [(ngModel)]="datum.values[6]"
                                                            (ngModelChange)="
                                                                    datum.transformDirty(true);
                                                                    updateDatumTransformFromMatrix(datum, datum.values)
                                                                "
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [(ngModel)]="datum.values[7]"
                                                            (ngModelChange)="
                                                                    datum.transformDirty(true);
                                                                    updateDatumTransformFromMatrix(datum, datum.values)
                                                                "
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [(ngModel)]="datum.values[8]"
                                                            (ngModelChange)="
                                                                    datum.transformDirty(true);
                                                                    updateDatumTransformFromMatrix(datum, datum.values)
                                                                "
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [(ngModel)]="datum.values[9]"
                                                            (ngModelChange)="
                                                                    datum.transformDirty(true);
                                                                    updateDatumTransformFromMatrix(datum, datum.values)
                                                                "
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [(ngModel)]="datum.values[10]"
                                                            (ngModelChange)="
                                                                    datum.transformDirty(true);
                                                                    updateDatumTransformFromMatrix(datum, datum.values)
                                                                "
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [(ngModel)]="datum.values[11]"
                                                            (ngModelChange)="
                                                                    datum.transformDirty(true);
                                                                    updateDatumTransformFromMatrix(datum, datum.values)
                                                                "
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [(ngModel)]="datum.values[12]"
                                                            (ngModelChange)="
                                                                    datum.transformDirty(true);
                                                                    updateDatumTransformFromMatrix(datum, datum.values)
                                                                "
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [(ngModel)]="datum.values[13]"
                                                            (ngModelChange)="
                                                                    datum.transformDirty(true);
                                                                    updateDatumTransformFromMatrix(datum, datum.values)
                                                                "
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [(ngModel)]="datum.values[14]"
                                                            (ngModelChange)="
                                                                    datum.transformDirty(true);
                                                                    updateDatumTransformFromMatrix(datum, datum.values)
                                                                "
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [(ngModel)]="datum.values[15]"
                                                            (ngModelChange)="
                                                                    datum.transformDirty(true);
                                                                    updateDatumTransformFromMatrix(datum, datum.values)
                                                                "
                                                        />
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </fieldset>
                                        <fieldset *ngIf="datum.getEntityType() === entityType.PLANE" [disabled]="true">
                                            <table>
                                                <tbody>
                                                <tr>
                                                    <td><span>Normal: </span></td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [(ngModel)]="datum.values[0]"
                                                            (ngModelChange)="
                                                                    datum.transformDirty(true);
                                                                    updateDatumTransformFromMatrix(datum, datum.values)
                                                                "
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [(ngModel)]="datum.values[1]"
                                                            (ngModelChange)="
                                                                    datum.transformDirty(true);
                                                                    updateDatumTransformFromMatrix(datum, datum.values)
                                                                "
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [(ngModel)]="datum.values[2]"
                                                            (ngModelChange)="
                                                                    datum.transformDirty(true);
                                                                    updateDatumTransformFromMatrix(datum, datum.values)
                                                                "
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><span>Distance: </span></td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [(ngModel)]="datum.values[3]"
                                                            (ngModelChange)="
                                                                    datum.transformDirty(true);
                                                                    updateDatumTransformFromMatrix(datum, datum.values)
                                                                "
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="4">
                                                            <span
                                                            ><i
                                                                class="icon-chevron glyphicon glyphicon-info-sign"
                                                            ></i
                                                            >Translation along Normal from Origin.</span
                                                            >
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </fieldset>
                                        <fieldset
                                            *ngIf="
                                                datum.getEntityType() === entityType.HOLE_PATTERN ||
                                                datum.getEntityType() === entityType.SLOT ||
                                                datum.getEntityType() === entityType.ARC_PAIR
                                            "
                                            [disabled]="true"
                                        >
                                            <table>
                                                <tbody *ngFor="let item of datum.state?.logicalStructure?.entityData">
                                                <tr>
                                                    <th colspan="100%">{{ item.type }}</th>
                                                </tr>
                                                <tr>
                                                    <td><span>Radius: </span></td>
                                                    <td>
                                                        <input type="number" [value]="formatNumber(item.radius)" />
                                                    </td>
                                                    <td><span>Depth: </span></td>
                                                    <td>
                                                        <input type="number" [value]="formatNumber(item.depth)" />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><span>Center 1: </span></td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [value]="formatNumber(item.center1.x)"
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [value]="formatNumber(item.center1.y)"
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [value]="formatNumber(item.center1.z)"
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><span>Center 2: </span></td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [value]="formatNumber(item.center2.x)"
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [value]="formatNumber(item.center2.y)"
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [value]="formatNumber(item.center2.z)"
                                                        />
                                                    </td>
                                                </tr>
                                                <tr *ngIf="item.type === 'SLOT'">
                                                    <td><span>Direction: </span></td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [value]="formatNumber(item.slotDir.x)"
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [value]="formatNumber(item.slotDir.y)"
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            [value]="formatNumber(item.slotDir.z)"
                                                        />
                                                    </td>
                                                </tr>
                                                <tr *ngIf="item.type === 'SLOT'">
                                                    <td><span>Width: </span></td>
                                                    <td>
                                                        <input type="number" [value]="formatNumber(item.width)" />
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </fieldset>
                                    </ng-template>
                                </ngb-panel>

                                <!-- Transform Component Editor -->
                                <ngb-panel
                                    id="components-panel"
                                    *ngIf="mode === threedMode.DATUM && datum.getEntityType() === entityType.TRANSFORM"
                                >
                                    <ng-template ngbPanelHeader let-opened="opened">
                                        <button ngbPanelToggle class="btn btn-link p-0">
                                            <i
                                                class="icon-chevron glyphicon glyphicon-triangle-right"
                                                *ngIf="!opened"
                                            ></i>
                                            <i
                                                class="icon-chevron glyphicon glyphicon-triangle-bottom"
                                                *ngIf="opened"
                                            ></i>
                                            Component Transforms
                                        </button>
                                    </ng-template>
                                    <ng-template ngbPanelContent>
                                        <div class="component-transform-content">
                                            <fieldset [disabled]="!datum.featureDescriptionOverride">
                                                <div
                                                    *ngFor="
                                                        let rotation of datum.transformComponents.rotations;
                                                        let i = index
                                                    "
                                                    id="rotations"
                                                >
                                                    <label for="{{ 'rotation-' + i }}">Rotation {{ i }}</label>
                                                    <select
                                                        id="{{ 'rotation-' + i }}"
                                                        [(ngModel)]="rotation.axis"
                                                        (ngModelChange)="updateDatumTransformFromComponents(datum, i)"
                                                    >
                                                        <option
                                                            *ngFor="let axis of generateAxesOptions(datum, i)"
                                                            [value]="axis"
                                                            [selected]=""
                                                        >
                                                            {{ axis }}
                                                        </option>
                                                    </select>
                                                    <input
                                                        type="number"
                                                        [(ngModel)]="rotation.angle"
                                                        (ngModelChange)="
                                                            datum.transformDirty(true);
                                                            updateDatumTransformFromComponents(datum, -1)
                                                        "
                                                    />
                                                </div>
                                                <div id="translations">
                                                    <label for="translations">Translation</label>
                                                    <table>
                                                        <tbody>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    [(ngModel)]="
                                                                            datum.transformComponents.translateX
                                                                        "
                                                                    (ngModelChange)="
                                                                            datum.transformDirty(true);
                                                                            updateDatumTransformFromComponents(
                                                                                datum,
                                                                                -1
                                                                            )
                                                                        "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    [(ngModel)]="
                                                                            datum.transformComponents.translateY
                                                                        "
                                                                    (ngModelChange)="
                                                                            datum.transformDirty(true);
                                                                            updateDatumTransformFromComponents(
                                                                                datum,
                                                                                -1
                                                                            )
                                                                        "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    [(ngModel)]="
                                                                            datum.transformComponents.translateZ
                                                                        "
                                                                    (ngModelChange)="
                                                                            datum.transformDirty(true);
                                                                            updateDatumTransformFromComponents(
                                                                                datum,
                                                                                -1
                                                                            )
                                                                        "
                                                                />
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </ng-template>
                                </ngb-panel>
                            </ngb-accordion>
                        </div>
                    </div>
                </ng-template>
            </ngb-panel>
        </ngb-accordion>
    </div>
</div>
